const RawData = [
  {
    roleId: '1', roleName: 'Master Data', parent: true,
    children: [
        { roleId: '1.1', roleName: 'Branch', parent: false, create:'', view: '', edit:'', 'Active / Inactive':'', delete:''},
        { roleId: '1.2', roleName: 'Department', parent: false, create:'', view: '', edit:'', 'Active / Inactive':'', delete:'' },
        { roleId: '1.3', roleName: 'Role',parent: false, create:'', view: '', edit:'', 'Active / Inactive':'', delete:'' },
        { roleId: '1.4', roleName: 'User', parent: false, create:'', view: '', edit:'', 'Active / Inactive':'', delete:'' },
        { roleId: '1.5', roleName: 'Committee Type', parent: false, create:'', view: '', edit:'', 'Active / Inactive':'', delete:'' },
        // { roleId: '1.6', roleName: 'Meeting Creation', parent: false, create:'', view: '', edit:'', 'Active / Inactive':'', delete:''},
    ]
  },
  // {
  //   roleId: '2', roleName: 'Meeting Creation', parent: true,
  //   children: [
        
  //   ]
  // },
];

export default RawData;